import {
  dominantArmObjs,
  fingerGuardTypeForBknModelObjs,
  fingerGuardTypeForOutfielderObjs,
  fingerGuardTypeForSkrModelObjs,
  fingerGuardTypeObjs,
  onlyRightThrowObjs
} from 'src/features/gorilla/constants/base'
import { Position, State, StateObj } from 'src/types'
import { positionChecker } from 'src/logic'

export const gorillaFlagGenerator = (state: State, position: Position) => {
  const { isPitcher } = positionChecker(position)
  const isSelectedSeries = state.series?.value !== 'unselected' || !isPitcher
  const isSelectableBaseSetting = isSelectedSeries
  const isBomberSeries = isPitcher && state.series.value === 'bomber'
  const isBKNModel = state.baseModel.productNumber === 'BKN-20'

  return {
    isSelectedSeries,
    isLeftThrow: state.dominantArm.value === 'leftThrow',
    isDefaultSize: state.size.value === 'default',
    isSelectableSeries: isPitcher,
    isSelectableDominantArm: isSelectableBaseSetting,
    isSelectableSize: isSelectableBaseSetting && isBomberSeries,
    isSelectableOthers: isSelectableBaseSetting && !isBomberSeries,
    isBKNModel
  }
}
export const dominantArmObjectSwitcher = (position: Position): StateObj[] => {
  switch (position) {
    case 'catcher':
      return onlyRightThrowObjs
    default:
      return dominantArmObjs
  }
}

export const fingerGuardTypeObjectSwitcher = (position: Position, productNumber: string): StateObj[] => {
  switch (position) {
    case 'pitcher':
      switch (productNumber) {
        case 'SKR-20':
          return fingerGuardTypeForSkrModelObjs
        default:
          return fingerGuardTypeObjs
      }
    case 'outfielder':
      switch (productNumber) {
        case 'BKN-20':
          return fingerGuardTypeForBknModelObjs
        default:
          return fingerGuardTypeForOutfielderObjs
      }
    default:
      return fingerGuardTypeObjs
  }
}

export const baseDescriptionGenerator = (condition: boolean, key: string): string => {
  if (condition) {
    switch (key) {
      case 'series':
        return '再選択したい場合はシミュレーションをリセットしてください'
      case 'dominantArm':
        return 'シミュレーションイメージは右投げ用が描画されます'
    }
  }
}
